import { Production } from '../../pages/ProductionPage';
import UnderConstructionPage from '../../underconstruction-page';
import {
  DailyProduction,
  CreateDailyProduction,
} from '../../pages/ProductionPage/dailyProductionRotor';
import {
  HourlyProductionReportList,
  CreateHourlyProductionReport,
} from '../../pages/ProductionPage/HourlyProductionReport';
import {
  DailyProductionRedBin,
  CreateDailyProductionRedBin,
} from '../../pages/ProductionPage/dailyProductionRedBin';
import {
  DailyRejectionRotorList,
  CreateDailyRejectionRotor,
} from '../../pages/ProductionPage/dailyProductionRotorDailyRejection';
import {
  DailyProductionStrokes,
  CreateDailyProductionStrokes,
} from '../../pages/ProductionPage/dailyProductionStrokes';

export const productions = [
  // daily prod rotor report
  {
    path: 'dailyProductionList',
    element: <DailyProduction />,
  },
  // daily prod press shop report report
  {
    path: 'production/pressShop/dailyProductionList',
    element: <DailyProduction />,
  },
  {
    path: 'production/pressShop/createEditDailyProduction/:id?',
    element: <CreateDailyProduction />,
  },

  // // daily rotor rejection report
  // {
  //   path: 'dailyProductionRotorDailyRejectionList',
  //   element: <DailyRejectionRotorList />,
  // },
  // {
  //   path: 'createEditDailyProductionRotorDailyRejection/:id?',
  //   element: <CreateDailyRejectionRotor />,
  // },

  // // hourly report
  // {
  //   path: 'rotorHourlyProductionList',
  //   element: <HourlyProductionReportList />,
  // },
  // {
  //   path: 'createHourlyProductionReports/:id?',
  //   element: <CreateHourlyProductionReport />,
  // },

  // // dailyprod strokes
  // {
  //   path: 'dailyProductionStrokesList',
  //   element: <DailyProductionStrokes />,
  // },
  // {
  //   path: 'createEditDailyProductionStrokes/:id?',
  //   element: <CreateDailyProductionStrokes />,
  // },

  // // prodRed bin
  // {
  //   path: 'dailyProductionRedBinList',
  //   element: <DailyProductionRedBin />,
  // },
  // {
  //   path: 'createEditDailyProductionRedBin/:id?',
  //   element: <CreateDailyProductionRedBin />,
  // },
];
